import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import { NotOperatorRoles } from 'shared/permissions/roles';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { productService, typeService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch, useAppSelector } from 'store/store';
import { Option } from 'shared/types/general';
import { SearchBar } from 'components/enhanced';
import { ProductsColumns } from '../products';

export const Products = () => {
  const translationPrefix = 'pages.product.list';

  const [types, setTypes] = useState<Option[]>([]);

  const sap_active = useAppSelector((state) => state.auth.sap_active);
  const [queryText, setQueryText] = useState<string>();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const groups = useAppSelector((state) => state.auth.groups);

  const datagridRefresh = useRef(null);

  useEffect(() => {
    dispatch(loadingActions.startLoading());
    typeService.getAllBaseInformation().then((res) => {
      setTypes(res);
    });

    dispatch(loadingActions.stopLoading());
  }, []);

  const columns: GridColDef[] = ProductsColumns(
    types.map((type) => type.code),
    datagridRefresh.current,
    sap_active,
    NotOperatorRoles.some((role) => groups.includes(role))
  );

  const onSubmitSearch = async (values) => {
    setQueryText(values['q']);
  };

  const memorizedInitialParams = useMemo(() => {
    const codeParam = searchParams.get('code');
    return codeParam ? { code: codeParam } : {};
  }, [searchParams]);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="products"
      menuRight={
        <div className="flex justify-end items-center gap-2">
          <SearchBar onSubmit={onSubmitSearch} />
          <AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />
        </div>
      }>
      <EnhancedDataGrid
        refresh={datagridRefresh}
        service={productService}
        columns={columns}
        initialParams={memorizedInitialParams}
        fullTextQuery={queryText}
        disableExport={true}
      />
    </TenantPage>
  );
};

export default Products;
